import { useFormContext } from 'react-hook-form';
import { Box, styled, Typography } from '@mui/material';

interface IDocumentViewerProps {
  name: string;
  onClick: () => void;
}

export const DocumentViewer = ({ name, onClick }: IDocumentViewerProps) => {
  const { getValues } = useFormContext();
  const content = getValues(name);

  return (
    <StyledBox onClick={onClick}>
      {content ? (
        <Box dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <Typography>등록된 내용이 없습니다.</Typography>
      )}
    </StyledBox>
  );
};

const StyledBox = styled(Box)(({ theme }) => ({
  cursor: 'pointer',
  padding: '10px',
  maxHeight: '300px',
  overflow: 'auto',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '4px',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));
